module.exports = __webpack_public_path__ + "img/ninedot-lock.0da84468.svg";